import Api from "../../../../shared/services/api"
import { NotificationPreferences, UpdateNotificationPreferencesRequest } from "../models/notification-preferences.model"

export const saveData = async (req: any): Promise<number> => {
    let url = '/users/save-settings';
    const params = Object.entries(req)
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

    if (params) {
        url += `?${params}`;
    }
    const result = await Api.post(url);
    return result.data;
}

export const getAppStatus = async (): Promise<boolean> => {
    const result = await Api.get(`/appStatus`);
    return result.data;
};

export const setAppStatus = async (): Promise<boolean> => {
    const result = await Api.get(`/appconfiguration/set-app-configuration`);
    return result.data;
};

export const getNotificationPreferences = async (): Promise<NotificationPreferences> => {
    const result = await Api.get('/users/me/notification-preferences');
    return result.data;
};

export const updateNotificationPreferences = async (req: UpdateNotificationPreferencesRequest): Promise<NotificationPreferences> => {
    const result = await Api.put('/users/me/notification-preferences', req);
    return result.data;
};
